import React from "react";
import Layout from "../Layout";
import Head from "next/head";
import { Box, ContentLoader, ResponsiveLayout } from "@bca/ui-library";
import { GalleryContainer } from "../ImageGallery";

interface VehicleDetailsSkeletonProps {
  authUser?: {
    firstName: string;
    lastName?: string;
  };
  idToken?: string;
  isAuthenticated?: boolean;
  logoutUrl?: string;
  isToUseAuthZero?: boolean;
}

const VehicleDetailsSkeleton: React.FC<VehicleDetailsSkeletonProps> = ({
  authUser,
  idToken,
  isAuthenticated,
  logoutUrl,
  isToUseAuthZero,
}) => {
  return (
    <Layout
      user={
        authUser
          ? {
              firstName: authUser.firstName,
              lastName: authUser.lastName || "",
            }
          : undefined
      }
      idToken={idToken}
      isToUseAuthZero={isToUseAuthZero}
      isAuthenticated={isAuthenticated}
      logoutUrl={logoutUrl}
    >
      <Head>
        <title>Loading...</title>
      </Head>
      <Box height={"100vh"} width="100%">
        <Box style={{ backgroundImage: "linear-gradient(#080f22, #070b16)" }}>
          <ResponsiveLayout>
            <GalleryContainer height={580}>
              <ContentLoader
                style={{ backgroundColor: "red" }}
                height={"100%"}
                title="Loading..."
                uniqueKey="2"
                width="100%"
              >
                <rect height={400} rx={4} ry={4} width={600} x={30} y={60} />
                <rect height={60} rx={4} ry={4} width={120} x={"71%"} y={360} />
                <rect height={60} rx={4} ry={4} width={120} x={"80%"} y={360} />
                <rect height={60} rx={4} ry={4} width={120} x={"89%"} y={360} />
                <rect height={80} rx={4} ry={4} width={80} x={30} y={480} />
                <rect height={80} rx={4} ry={4} width={80} x={130} y={480} />
              </ContentLoader>
            </GalleryContainer>
          </ResponsiveLayout>
        </Box>
        <ResponsiveLayout>
          <ContentLoader
            height={100}
            title="Loading..."
            uniqueKey="1"
            width="100%"
          >
            <rect height={100} rx={4} ry={4} width={"95%"} x={30} y={6} />
          </ContentLoader>
        </ResponsiveLayout>
      </Box>
    </Layout>
  );
};

export default VehicleDetailsSkeleton;
